import { AxiosError } from 'axios';
import { GET_NON_NATIONAL_EXAM_CANDIDATE_DETAILS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { GenericErrorResponse } from '../typings';
import { useCustomQuery } from '../utils/useCustomQuery';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface GetNonNationalCandidateDetailsResponse {
  declaringPerson: {
    name: string;
    uinFinPassport: string;
  };
  singaporeBirthCertNo: string;
  motherTongueLanguageToBeTaken: string;
  dateOfAttainedSPRStatus: string;
  citizenshipType: string;
  lockedByUser?: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess: (data: GetNonNationalCandidateDetailsResponse) => void;
  onError: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalCandidateDetails = ({ uuid, onSuccess, onError }: Input) => {
  const getNonNationalCandidateDetails = async () => {
    const res = await axiosClient.get<GetNonNationalCandidateDetailsResponse>(
      GET_NON_NATIONAL_EXAM_CANDIDATE_DETAILS(uuid)
    );

    return res.data;
  };

  return useCustomQuery(
    [GET_NON_NATIONAL_EXAM_CANDIDATE_DETAILS(uuid)],
    getNonNationalCandidateDetails,
    {
      onSuccess,
      onError,
    }
  );
};
